var stats = function(global,response) {
    global.name = response.name;
    global.completed_at = response.completed_at;
    global.created_at = response.created_at;
    global.elapsed_time = response.elapsed_time;
    // sort them!
    _(response.answers).each(function(answer){
        var chapter = answer.question.question_chapter;

        if (typeof global.chapterOrder[chapter.chapter_order] == 'undefined') {
            global.chapterOrder[chapter.chapter_order] = chapter.name;
        }
        if (typeof global.chapters[chapter.name] == 'undefined') {
            global.chapters[chapter.name] = {
                total:0, correct : 0, incorrect : 0, skipped : 0, unseen: 0, answers : []
            }
        }

        global.chapters[chapter.name].answers.push(answer);
        global.chapters[chapter.name].total++;
        global.all.answers.push(answer);
        global.all.total++;
        switch ( answer.status ) {
            case "correct":
                global.chapters[chapter.name].correct++;
                global.all.correct++;
                break;
            case "incorrect":
                global.chapters[chapter.name].incorrect++;
                global.all.incorrect++;
                break;
            case "skipped":
                global.chapters[chapter.name].skipped++;
                global.all.skipped++;
                break;
            case "unseen":
                global.chapters[chapter.name].unseen++;
                global.all.unseen++;
                break;
        }
    });
}

module.exports = stats;


//////////////////
// WEBPACK FOOTER
// ./src/stats.js
// module id = 234
// module chunks = 0